import { APP_META_TRAVEL_ADS_API_ENDPOINT } from "constants/api_urls";
import axios from "axios";
import { getUserToken } from "utils/functions/userToken";

export const createCampaign = async (campaignDetails) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.put(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/add-campaign/`,
            campaignDetails,
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage = error?.response?.data || "Failed to create campaign";
        return { success: false, error: errorMessage };
    }
};